import React, { useRef } from 'react'
import Typography from '@mui/material/Typography'

import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import DialogActions from '@mui/material/DialogActions'
import Paper from '@mui/material/Paper'
import Draggable from 'react-draggable'
import { makeStyles } from '@mui/styles'
import { ResizableBox } from 'react-resizable'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import IconTooltipButton from '../button/IconTooltipButton'

/**
 * This Dialog is custom styles and functionalities for used inside Maestro,
 * @param {Object}
 *   * @param {String}   id - Identificador
 *   * @param {Boolean}  show - Open dialog
 *   * @param {Object}   title - Title Dialog
 *   * @param {Boolean}  headerModule - Show Style header
 *   * @param {Function} onCloseHeader - Action close in heacder
 *   * @param {Boolean}  fullWidth - Full width
 *   * @param {String}   maxWidth - size max width dialog
 *   * @param {Object}   children
 *   * @param {Object}   buttons - actions buttons
 *   * @param {Function} onClose - Action close
 *   * @param {Object}   scroll -  height for scroll  content body dialog
 *   * @param {String}   theme - style theme
 *   * @param {Boolean}  resizable - resizable dialog
 *   * @param {Number}   height - height dialog
 *   * @param {Number}   width - width dialog
 *   * @param {Object}   actions - actions buttons React
 */

function PaperComponent(props) {
  const ref = useRef()
  return (
    <Draggable
      nodeRef={ref}
      handle={`#${props['aria-labelledby']}`}
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={ref} />
    </Draggable>
  )
}

const useStyles = makeStyles(() => ({
  resizable: {
    position: 'relative',
    '& .react-resizable-handle': {
      position: 'fixed',
      width: 20,
      height: 20,
      bottom: 0,
      right: 0,
      background:
        "url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2IDYiIHN0eWxlPSJiYWNrZ3JvdW5kLWNvbG9yOiNmZmZmZmYwMCIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI2cHgiIGhlaWdodD0iNnB4Ij48ZyBvcGFjaXR5PSIwLjMwMiI+PHBhdGggZD0iTSA2IDYgTCAwIDYgTCAwIDQuMiBMIDQgNC4yIEwgNC4yIDQuMiBMIDQuMiAwIEwgNiAwIEwgNiA2IEwgNiA2IFoiIGZpbGw9IiMwMDAwMDAiLz48L2c+PC9zdmc+')",
      'background-position': 'bottom right',
      padding: '0 3px 3px 0',
      'background-repeat': 'no-repeat',
      'background-origin': 'content-box',
      'box-sizing': 'border-box',
      cursor: 'se-resize'
    }
  }
}))

const DialogCustom = ({
  id,
  show,
  headerModule = true,
  onCloseHeader,
  fullWidth = true,
  children,
  onClose,
  title,
  maxWidth = 'xs',
  resizable = false,
  height = 300,
  width = 300,
  actions,
  loading
}) => {
  const classes = useStyles()
  const idd = id?.split(' ')?.join('-') || title?.split(' ')?.join('-')?.toLowerCase()
  return (
    <Dialog
      id={`dialog-${idd}`}
      open={show}
      backdropclick={'false'}
      disableEscapeKeyDown={false}
      fullWidth={resizable ? false : fullWidth}
      maxWidth={resizable ? false : maxWidth}
      className={`bg-background`}
      onClose={onClose}
      style={{ backgroundColor: 'transparent' }}
      aria-describedby={`dialog-${idd}-description`}
      PaperComponent={PaperComponent}
      aria-labelledby={`dialog-${idd}-labelledby`}
    >
      <DialogTitle component={'div'} className='flex justify-between items-center'>
        {headerModule ? (
          <Typography variant='h6' component={'div'} className='uppercase'>
            {title}
          </Typography>
        ) : (
          <div />
        )}
        {onCloseHeader && (
          <div>
            <IconTooltipButton
              color='secondary'
              title='Close'
              className='z-12'
              onClick={onClose}
              icon={['fal', 'times']}
            />
          </div>
        )}
      </DialogTitle>
      <DialogContent dividers={true} style={{ position: 'relative' }}>
        {loading ? (
          <div className='flex justify-center items-center'>
            <FontAwesomeIcon icon={['fal', 'spinner-third']} spin size='2x' />
          </div>
        ) : resizable ? (
          <ResizableBox
            minConstraints={[width, height]}
            height={height}
            width={width}
            className={classes.resizable}
          >
            {children}
          </ResizableBox>
        ) : (
          children
        )}
      </DialogContent>
      {actions && <DialogActions>{actions}</DialogActions>}
    </Dialog>
  )
}

export default DialogCustom
